import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IoDiamond } from 'react-icons/io5';
import { FaCrown } from 'react-icons/fa6';
import { determineDisabledFeature } from '../../utils/determineDisabled';
import DiamondIcon from '../../assets/disabledFeature/DiamondIcon';
import './DisabledFeature.scss';
import { t } from '../../i18n/i18n';
import BadgePro from '../BadgePro/BadgePro';

const DisabledFeature = ({
  children,
  featureId,
  validateAmount,
  usedAmount,
  className,
  iconClassName,
  childrenClassname,
  iconSize = 'small',
  hideOnDisabled = false,
  hideDiamond = false,
  badgePro = false,
  crown = false,
}) =>
  determineDisabledFeature({ featureId, validateAmount, usedAmount }) ? (
    <div
      className={`border-1 ${hideOnDisabled ? 'd-none' : className ?? 'd-flex flex-column'} ${
        className && !className.includes('py-0') ? 'py-2' : ''
      }`}
    >
      {!hideDiamond && (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip>
              <span className=" font-weight-bold text-xs mb-2">
                {validateAmount
                  ? t('NO_MORE_AVAILABLE_USAGE_FOR_THIS_FUNCTION_CONTACT_SALES_TEAM')
                  : t('AVAILABLE_IN_PREMIUM_CONTACT_SALES_TEAM')}
              </span>
            </Tooltip>
          }
        >
          <div className="flex">
            {badgePro ? (
              <BadgePro
                onlyIcon
                icon={
                  crown ? (
                    <FaCrown color="#FFAB3B" size="18px" />
                  ) : (
                    <IoDiamond color="#FFAB3B" size="18px" />
                  )
                }
              />
            ) : (
              <a
                className={`mx-1 mr-3 text-xs diamond-background d-flex align-items-center justify-content-center rounded-circle ${iconClassName}`}
                href={process.env.RAZZLE_RUNTIME_SALES_CALENDAR_URL}
              >
                <DiamondIcon className={`diamond-icon-${iconSize}`} />
              </a>
            )}
          </div>
        </OverlayTrigger>
      )}
      <div
        style={{ pointerEvents: 'none', filter: 'grayscale(1)' }}
        role="button"
        className={`cursor-disabled ${childrenClassname}`}
        tabIndex={0}
        onKeyDown={(e) => {
          e.stopPropagation();
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {children}
      </div>
    </div>
  ) : (
    children
  );

export default DisabledFeature;
